import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import TabPropTypes from './Tab.propTypes';
import Tab from './Tab';

const TabNav = ({ isSkeuomorphic, className, tabs, handleSelectTab }) => {
	const classes = classnames('c-m-tab-nav', className, { 'c-m-tab-nav--skeuomorphic': isSkeuomorphic });
	return (
		<ul role="tablist" className={classes}>
			{tabs && tabs.map((tab) => <Tab {...tab} key={tab.id} handleSelectTab={handleSelectTab} />)}
		</ul>
	);
};

TabNav.propTypes = {
	isSkeuomorphic: PropTypes.bool,
	className: PropTypes.string,
	tabs: PropTypes.arrayOf(PropTypes.shape(TabPropTypes)),
	handleSelectTab: PropTypes.func.isRequired,
};

export default TabNav;
